import styled from 'styled-components';

import { Text } from '@/nova/components/Text/Text';
import { COLORS, SPACE } from '@/nova/theme/tokens';

/* The in-place asset overlay's "can't be opened here" dialog (while an asset loads there is only a toast pill, so the
   composer's own Sheet is the one that opens). */

export const MissingText = styled(Text).attrs({ tag: 'paragraph' as const })`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: ${COLORS.textMuted};
`;

export const MissingActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: ${SPACE[8]};
`;
